import React, { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableRow, TableHead } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import axiosConfig from "../../utils/axiosConfig";
const useStyles = makeStyles((theme) => ({
  tableHeadRows: {
    whiteSpace: "nowrap",
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontSize: 12,
    lineHeight: '18px',
    color: 'rgba(181, 181, 195, 1)',
    border: 0,
    background: 'rgba(243, 246, 249, 1)',
    padding: '1%'
  },
  tableCellSmall1: {
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontSize: 15,
    lineHeight: '22.5px',
    color: 'rgba(70, 78, 95, 1)',
    borderBottom: '1px solid rgba(0, 0, 0, 0.08)'
  },
  tableCellSmall: {
    fontFamily: 'Poppins',
    fontWeight: 400,
    fontSize: 15,
    lineHeight: '22.5px',
    color: 'rgba(70, 78, 95, 1)',
    borderBottom: '1px solid rgba(0, 0, 0, 0.08)'
  },
}));

function HistoriqueSection(props) {
  const classes = useStyles();
  const [historiqueData, setHistoriqueData] = useState([]);
  const claimNumber = props.claimNumber ; 

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosConfig.get(`${process.env.REACT_APP_BACKEND_URL_MS_CLAIMMANAGEMENT}/eventLog/${claimNumber}`);
        const data = response.data.map(event => ({
          action: event.textDescription,
          comment: event.comment,
          date: formatDateTime(event.dateTime)
        }));
        setHistoriqueData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  const formatDateTime = (dateTimeString) => {
    const date = new Date(dateTimeString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };
  return (
    <div style={{ padding: "40px" }}>
      <Table className={classes.table} aria-labelledby="tableTitle" size="small">
        <TableHead>
          <TableRow>
            <TableCell width={'50%'} height={'43px'} align="left" className={classes.tableHeadRows} style={{ borderTopLeftRadius: '6px', borderBottomLeftRadius: '6px' }}>Action</TableCell>
            <TableCell width={'30%'} height={'43px'} align="left" className={classes.tableHeadRows}>Utilisateur</TableCell>
            <TableCell width={'20%'} height={'43px'} align="right" className={classes.tableHeadRows} style={{ borderTopRightRadius: '6px', borderBottomRightRadius: '6px' }}>Date</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {
            historiqueData.map((historique, index) => (
              <TableRow hover key={index} style={{ height: "48px" }}>
                <TableCell align="left" width={'50%'} className={classes.tableCellSmall1}>
                  {historique.action} <a href="#" style={{ color: 'rgba(187, 200, 8, 1)' }}>{historique.expert}</a>
                </TableCell>
                <TableCell align="left" width={'30%'} className={classes.tableCellSmall}>
                  {historique.comment}
                </TableCell>
                <TableCell align="right" width={'20%'} className={classes.tableCellSmall}>
                  {historique.date}
                </TableCell>
              </TableRow>
            ))
          }
        </TableBody>
      </Table>
    </div>
  );
}

export default HistoriqueSection;
